import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { NAV } from "../lib/nav";

export default function BookPicker() {
  const { tab } = useParams();
  const [books, setBooks] = useState(null);
  useEffect(() => { api.get("/books").then((r) => setBooks(r.data)); }, []);
  const nav = NAV.find((n) => n.id === tab);
  return (
    <div>
      <p className="eyebrow mb-2">Studio</p>
      <h1 className="font-display text-4xl sm:text-5xl mb-3">{nav?.label}</h1>
      <p className="text-slate-400 mb-10">Choose a book to open in this studio.</p>
      {books?.length === 0 && <p className="text-slate-500" data-testid="picker-empty">No books yet. Create one in <Link to="/app" className="text-amber-400">My Books</Link>.</p>}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {books?.map((b) => (
          <Link key={b.id} to={`/app/books/${b.id}?tab=${tab}`} className="panel p-5 hover:border-amber-500/40 transition-colors" data-testid={`picker-book-${b.id}`}>
            <p className="font-display text-lg">{b.title}</p>
            <p className="text-xs text-slate-500 mt-1">{b.current_version ? `v${b.current_version.number} · ${b.current_version.word_count.toLocaleString()} words` : "No manuscript"}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
